import { logDispatcher } from 'src/app/core/decorators/state.decorators';
import { StudentEngagementData } from '../models/engagement-student.model';
import { SchoolEngagementData } from '../models/engagement-school.model';

export namespace EngagementActions {
  @logDispatcher
  export class AddStudentEngagement {
    static readonly type = '[Engagements] AddStudentEngagement';
    constructor(public user: string) {}
  }

  @logDispatcher
  export class AddStudentEngagementSuccess {
    static readonly type = '[Engagements] AddStudentEngagementSuccess';
    constructor(public engagementId: number) {}
  }

  @logDispatcher
  export class DeleteStudentEngagement {
    static readonly type = '[Engagements] DeleteStudentEngagement';
    constructor(public engagementId: number, public studentId: number) {}
  }

  @logDispatcher
  export class DeleteStudentEngagementSuccess {
    static readonly type = '[Engagements] DeleteStudentEngagementSuccess';
    constructor(public studentId: number, public studentEngagementId: number) {}
  }

  @logDispatcher
  export class SetStudentEngagementDefaultState {
    static readonly type = '[Engagements] SetStudentEngagementDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class SetCopyEngagementsFormDefaultState {
    static readonly type = '[Engagements] SetCopyEngagementsFormDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class SetCopyEngagementsFormExercises {
    static readonly type = "[Engagements] SetCopyEngagementsFormExercises"
    constructor(public newExerciseId: number, public oldExerciseId: number) {}
  }

  @logDispatcher
  export class CopyEngagements {
    static readonly type = "[Engagements] CopyEngagements"
    constructor() {}
  }

  @logDispatcher
  export class CopyEngagementsSuccess {
    static readonly type = "[Engagements] CopyEngagementsSuccess"
    constructor() {}
  }

  @logDispatcher
  export class GetSchoolEngagement {
    static readonly type = '[Engagements] GetSchoolEngagement';
    constructor(public schoolId: number, public serviceId: number, public year: number, public month: number, public day: number) {}
  }
  

  @logDispatcher
  export class GetSchoolEngagementSuccess {
    static readonly type = '[Engagements] GetSchoolEngagementSuccess';
    constructor(public schoolEngagement: SchoolEngagementData) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Engagements] Error';
    constructor(public error: any) {}
  }
}
